define([], () => {
    return [() => {
        const service = {
            getSessionId: () => getSessionId(),
        };

        const { nanoid } = require("nanoid/non-secure");

        let sessionId;

        function getSessionId() {
            return sessionId === undefined ? generateSessionId() : sessionId;
        }

        function generateSessionId() {
            sessionId = nanoid();
            return sessionId;
        }

        return service;
    }]
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/SessionIdService.js